/* eslint-disable camelcase */
import { useQuery } from 'react-query';

import { api } from '../api';

interface GetRelatoriosExportados {
  id: number;
  transactionType: string;
  user: any;
  path: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
}

export async function getRelatoriosExportados(): Promise<
  GetRelatoriosExportados[]
> {
  const { data } = await api.get('transactions/export-transactions');

  return data;
}

export function useRelatoriosExportados() {
  return useQuery(['relatorios-exportados'], getRelatoriosExportados,
    {
      retry: 2
    });
}
